import { Component } from "@angular/core";
import { FormBuilder, Validators, AbstractControl, FormGroup, ValidatorFn, ValidationErrors } from "@angular/forms";
import { Router } from "@angular/router";
import { AdminProfileDataService } from "src/app/admin-profile-data.service";
import { EncryptionService } from "src/app/encryption.service";
import { VendorService } from "src/app/services/vendor.service";
import { SnackBarService } from "src/app/shared/services/snack-bar.service";
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';


export function lowercaseValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    const hasLowercase = /[a-z]/.test(value);
    return hasLowercase ? null : { lowercase: true };
  };
}


@Component({
  selector: "app-vendor-registration",
  templateUrl: "./vendor-registration.component.html",
  styleUrls: ["./vendor-registration.component.scss"],
})
export class VendorRegistrationComponent {
  bestBoys: any[] = [{ name: 'Vendor', value: 'VENDOR' }, { name: 'Business Partner', value: 'AGENT' }];
  bestBoys2: string[] = ['Vendor', 'Business Partner'];
  
  form: any;
  showpassword: boolean = false;
  confirmPasswordVisible: boolean = false;
  confirmPasswordhide = true;
  plans: any = [];
  hide = true;
  validateForm: FormGroup;
  refaralData: any;
  referralValidated: boolean = false;
  seletedRole: any;
  showRoleError: boolean = false;

  referralChecked = false;
  referralValid = false;
  userStartedTypingReferral = false;
  showValidateButton = true;
  selectedDog: string | null = null;

  constructor(
    private fb: FormBuilder,
    private vendorService: VendorService,
    private router: Router,
    private adminProfileDataService: AdminProfileDataService,
    private encryptionService: EncryptionService,
    private snackbarService: SnackBarService,

  ) {
    this.validateForm = this.fb.group({
      referral_code: [''] // no Validators.required
    });


  }


  initVendorRegistration() {
    this.form = this.fb.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      role: [''],
      referral_code: [''],
      p: ['', [
        Validators.required,
        Validators.minLength(8),
        lowercaseValidator()
      ]],
      confirm_password: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [
        Validators.required,
        Validators.pattern('^[0-9]{10}$'),
        Validators.minLength(10),
        Validators.maxLength(10)
      ]],
    }, { validator: this.passwordMatchValidator });
  }


  passwordMatchValidator(form: FormGroup) {
    const password = form.get('p')?.value;
    const confirmPassword = form.get('confirm_password')?.value;

    return password === confirmPassword ? null : { mismatch: true };
  }


  clearReferral() {
    this.validateForm.get('referral_code')?.setValue('');
  }


  ngOnInit(): void {
    this.initVendorRegistration();
    // this.getAllPlans();

    this.validateForm.get('referral_code')?.valueChanges.subscribe(value => {
      this.referralValid = false;
      this.referralChecked = false;
    });

    // this.validateForm.get('referral_code')?.valueChanges.subscribe(value => {
    //   if (value && !this.userStartedTypingReferral) {
    //     this.userStartedTypingReferral = true;
    //     this.referralChecked = false;
    //     this.referralValid = false;
    //   } else if (!value) {
    //     this.userStartedTypingReferral = false;
    //     this.referralChecked = false;
    //     this.referralValid = false;
    //   }
    // });


    this.validateForm.get('referral_code')?.valueChanges
  .pipe(debounceTime(400), distinctUntilChanged())
  .subscribe(code => {
    if (code?.length >= 3) {
      this.referralChecked = false;
      this.referralValid = false;
      this.showValidateButton = true; // show validate again on new input
    }
  });
    
  }


  toggleShowPassword() {
    this.showpassword = !this.showpassword;
  }

  toggleConfirmPasswordVisibility() {
    this.confirmPasswordVisible = !this.confirmPasswordVisible;
  }

  // passwordMatcher(control: AbstractControl): { [key: string]: boolean } | null {
  //   const password = control.get("password");
  //   const confirmPassword = control.get("confirm_password");
  //   return password &&
  //     confirmPassword &&
  //     password.value !== confirmPassword.value
  //     ? { passwordMismatch: true }
  //     : null;
  // }

  passwordPatternValidator(control: AbstractControl) {
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$*])[A-Za-z\d@$*]+$/;
    return passwordRegex.test(control.value) ? null : { invalidPassword: true };
  }



  vendorRegistration() {
    let reqObj = {
      first_name: this.form.value["first_name"],
      last_name: this.form.value["last_name"],
      // password: this.form.value["password"],
      p: this.encryptionService.encrypt256(this.form.value["p"]),
      confirm_password: this.form.value["confirm_password"],
      email: this.form.value["email"],
      mobile: this.form.value["mobile"],
      referral_code: this.validateForm.value["referral_code"],
      role: this.seletedRole,

    };

    console.log("From", this.form.value);
    console.log("reqObj", reqObj);
    this.vendorService.vendorRegistration(reqObj).subscribe((resp: any) => {
      console.log("Rec vendor Created success", resp);
      this.vendorService.setRegistrationData(resp);

      if (resp.statusCode == 200) {
        this.snackbarService.open(resp.supportMessage, 'close', 5000, "center", "top")
        // this.getReferralName();
        this.router.navigate(["/vendor-success"]);
        // console.log("Vendor Registered successfully")
      }
    });
  }


  emailVendorVerification() {
    let reqObj = {
      first_name: this.form.value["first_name"],
      last_name: this.form.value["last_name"],
      password: this.form.value["password"],
      confirm_password: this.form.value["confirm_password"],
      email: this.form.value["email"],
      mobile: this.form.value["mobile"],
      referral_code: this.form.value["referral_code"],
    };

    console.log("From", this.form.value);
    console.log("reqObj", reqObj);
    this.vendorService.emailVendorVerification(reqObj).subscribe((resp: any) => {
      console.log("Rec vendor Created success", resp);
      this.vendorService.setRegistrationData(resp);

      if (resp.statusCode == 200) {
        this.router.navigate(["vendor/vendor-success"]);
        // console.log("Vendor Registered successfully")
      }
    });
  }

  getAllPlans() {
    let reqObj = {};
    this.adminProfileDataService
      .getAllPlans(reqObj)
      .subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.plans = response.data;
          console.log("Plans data fetched successfully");
        } else {
          console.error("Error fetching data:", response.error);
        }
      });
  }


  isPatternError(controlName: string): boolean {
    const control = this.form.get(controlName);
    return !!control?.hasError('pattern') && control.touched;
  }

  isRequiredError(controlName: string): boolean {
    const control = this.form.get(controlName);
    return !!control?.hasError('required') && control.touched;
  }

  isMinLengthError(controlName: string): boolean {
    const control = this.form.get(controlName);
    return !!control?.hasError('minlength') && control.touched;
  }

  hasNumber(value: string): boolean {
    return /\d/.test(value);
  }

  hasSpecialCharacter(value: string): boolean {
    return /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(value);
  }

  hasUppercaseLetter(value: string): boolean {
    return /[A-Z]/.test(value);
  }

  hasLowercaseLetter(value: string): boolean {
    return /[a-z]/.test(value);
  }

  goTo(link: any) {
    this.router.navigate([link]);
  }

  get isSubmitEnabled() {
    return this.validateForm.valid && this.referralValidated;
  }

  onSubmit() {
    this.form.markAllAsTouched();
  
    // Check if role is selected
    if (!this.seletedRole) {
      this.showRoleError = true;
      return; // 🔴 Stop submission
    }
  
    // Check if form is valid
    if (this.form.invalid) {
      return; // 🔴 Stop submission
    }
  
    // Referral code validation (if you use it)
    const code = this.validateForm.value.referral_code;
    if (this.userStartedTypingReferral && code && !this.referralValid) {
      alert("Please validate the referral code before submitting.");
      return; // 🔴 Stop submission
    }
  
    // ✅ All validations passed, now call the API
    this.vendorRegistration();
  }

  getReferralName() {
    const referralCode = this.validateForm.value["referral_code"];
  
    if (!referralCode || referralCode.trim().length === 0) return;
  
    const reqObj = { reg_id: referralCode };
  
    this.vendorService.getReferralName(reqObj).subscribe((response: any) => {
      this.referralChecked = true;
  
      if (response.statusCode === 200) {
        this.refaralData = response.data;
        this.referralValid = true;
      } else {
        this.refaralData = null;
        this.referralValid = false;
      }
    });
  }

  // getReferralName() {
  //   this.referralChecked = true;
  //   this.referralValid = true;
  
  //   const reqObj = { reg_id: this.validateForm.value["referral_code"] };
  
  //   this.vendorService.getReferralName(reqObj).subscribe((response: any) => {
  //     // this.referralChecked = true;
  
  //     if (response.statusCode === 200) {
  //       this.refaralData = response.data;
  //       // this.referralValid = true;
  
  //       // Hide validate button after successful response
  //       this.showValidateButton = false;
  //     } else {
  //       this.refaralData = null;
  //       this.referralValid = false;
  //       this.showValidateButton = true; // keep it for retry
  //     }
  //   });
  // }



  toggleSelection(obj: any) {
    this.seletedRole = obj;
    this.showRoleError = false; // hide error once selected
    console.log("seletedRole ===", this.seletedRole)
  }

  selectDog(dog: string) {
    this.selectedDog = dog;
  }


}
